import type { GiantId } from '../ids/ids';

/** Короткие имена заказчиков для UI (канон из v1 `giantDisplayNames`, id v3). */
export const GIANT_DISPLAY_NAME: Record<GiantId, string> = {
  svami: 'Правители Свами',
  roza: 'Обсерватория Роза',
  drakochi: 'Дракочи',
  yetti: 'Йети',
  mona: 'Мона',
  duck: 'Капитан Уточка',
  serj: 'Серж',
  factor: 'Фактор',
  willy: 'Дядюшка Вилли',
  sol: 'Сол',
  mu: 'Луна Му',
};

export function getGiantDisplayName(giantId: GiantId): string {
  return GIANT_DISPLAY_NAME[giantId];
}
